import {
  CHECK_BOX_VALUE,
  ERP_SALES_ORDER_ITEMS_DATA,
  COMMON_DROPDOWN_OPTIONS,
  GRID_ROWS_PER_PAGE,
  SWITCH_VALUE,
} from '../../../constants';

export const initialState = {
  selectedTab: 0,
  loading: false,
  loadingForfetchERPSalesOrderItemsData: false,
  inputError: null, // You can store the input error here
  errors: {}, // You can store the form errors here
  isResultsFound: false, // variable for result found here
  errorModal: null, // variable for error modal here
  noDataFound: false, // variable for no data found here
  alertDialog: false, // variable for alert dialog here
  alertText: ERP_SALES_ORDER_ITEMS_DATA.errorMsg, // variable for alert text here
  apiSuccessResponse: {
    create: false,
    update: false,
    fastfindResult: false,
    updateUnsupportedDisplayData: false,
  }, // You can store the api success response here

  //--Common--
  //Radio Selection for Search Options
  searchOption: ERP_SALES_ORDER_ITEMS_DATA.searchOption1,

  //Display Button Status
  erpSalesOrderItemsDisplayStatus: false,
  isUnsupportedFlagUpdated: false,

  //--Search with Multiple Inputs on Top--
  //ERP Sales Order Items Search Data and Count
  erpSalesOrderItemsSearchData: [], // You can store the erpSalesOrder search data here
  erpSalesOrderItemSearchGridLoading: false,
  erpSalesOrderItemsCount: 0, // You can store the total records of the grid here
  isErpSalesOrderItemsResultsFound: false, // variable for result found here
  erpSalesOrderItemsGridSelectedRow: [], // variable for selected row data
  erpSalesOrderItemsUnsupportedFlag: CHECK_BOX_VALUE.no, // variable for unsupported flag here

  //Form Dates Labels
  erpSalesOrderItemSearchFormDateNames: {
    shipDate: 'Ship Date',
    importDate: 'Import Date',
  },

  //Form Dates Field Names
  erpSalesOrderItemSearchFormDates: {
    shipFromDate: 'shipFromDate',
    shipToDate: 'shipToDate',
    importFromDate: 'importFromDate',
    importToDate: 'importToDate',
  },

  erpSalesOrderItemSearchForm: {
    shipFromDate: null,
    shipToDate: null,
    importFromDate: null,
    importToDate: null,
    salesProductId: '',
    salesProductName: ERP_SALES_ORDER_ITEMS_DATA.inputModalDefaultVal,
    masterCustomerNumber: '',
    masterCustomerName: '',
    customerNameContains: '',
    accountingGroupCode: '',
    accountingGroupName: '',
    importStatusOperator: COMMON_DROPDOWN_OPTIONS.importstatus_operators[0],
    importStatusId: 3,
    importStatus: '',
    mappingTypeId: 0,
    mappingTypeName: '',
    orderGroupId: 0,
    orderGroupName: '',
    mappingReviewed: '',
  },

  //--Search with Fast Find Search Options on Bottom--
  erpSalesOrderItemsFastSearchData: [], // You can store the erpSalesOrder search data here
  erpSalesOrderItemsFastSearchCount: 0, // You can store the total records of the grid here
  isErpSalesOrderItemsFastSearchResultsFound: false, // variable for result found here
  erpSalesOrderItemsFastSearchForm: {
    orderNumber: '',
    lineNumber: '',
    shipDate: null,
  },

  //--Modals Search--
  isAccountingGroupsResultsFound: false, // variable for result found here
  isSalesProductResultsFound: false, // variable for result found here
  isMcnAccountingGroupsResultsFound: false,
  erpSalesOrderItemsSearchModal: {
    //Accounting Group Modal
    openAccountingGroupModal: false, // You can store AccountingGrouo modal open status here
    accountingGroupSearchData: [], // You can store the AccountingGrouo search data here
    gridAccountingRowSelectedData: [], // You can store the grid row selected data here
    gridAccountingRowSelectedCount: 0, // You can store the grid rows selected count
    accountingGroups: [], // You can store the accounting groups here
    accountingGroupGridTotalRecords: 0, // You can store the total records of the grid here
    accountingGroupSearchForm: {
      accountingGroupCode: '',
      isActive: SWITCH_VALUE.yes,
      isResellerGroup: SWITCH_VALUE.blank,
    },

    //Sales Product Modal
    salesProductModal: {
      // searchbox modal pop up product service name/code api states
      searchProductCodeNameLoading: false,
      searchProductCodeNameResult: [],
      searchProductCodeNameTotalRecords: 0,

      //modal open/close state
      openSalesProductModal: false,

      //display name on input field states
      codeField: '',
      nameField: '',
      salesProductField: '',
      serviceLevelId: 0,

      //object for capturing selected row data from modalpopup
      salesModalData: {
        id: 0,
        erpSalesProductId: 0,
        salesProductCode: '',
        salesProductName: '',
      },
    },

    //Master Customer Number Modal
    globalCustomerNo: '',
    multipleInputsSelectedValues: {
      name: '',
      accountingGroup: '',
      accountingGroupName: '',
      parentPsCustomerCode: '',
      activeFlag: '',
      corporateCustomer: '',
      billtoCustomer: '',
      pageIndex: GRID_ROWS_PER_PAGE.initialVal,
      recordCount:
        GRID_ROWS_PER_PAGE.erpSalesOrderItemsGlobalCustomerNumberGrid,
    },
    dropDownValues: {
      activeFlag: ERP_SALES_ORDER_ITEMS_DATA.dropDownDefaultValueForAny,
      corporateCustomer: ERP_SALES_ORDER_ITEMS_DATA.dropDownDefaultValueForAny,
      billtoCustomer: ERP_SALES_ORDER_ITEMS_DATA.dropDownDefaultValueForAny,
    },
    selectedCustomerNameInputValue: {
      name: '',
      accountingGroup: '',
      parentPsCustomerCode: '',
      activeFlag: '',
      corporateCustomer: '',
      billtoCustomer: '',
      pageIndex: GRID_ROWS_PER_PAGE.initialVal,
      recordCount:
        GRID_ROWS_PER_PAGE.erpSalesOrderItemsGlobalCustomerNumberGrid,
    },
    accountingGroupModal: {
      //Accounting Group
      openAccountingGroupModal: false, // You can store AccountingGrouo modal open status here
      accountingGroupSearchData: [], // You can store the AccountingGrouo search data here
      gridAccountingRowSelectedData: [], // You can store the grid row selected data here
      gridAccountingRowSelectedCount: 0, // You can store the grid rows selected count
      accountingGroups: [], // You can store the accounting groups here
      accountingGroupGridTotalRecords: 0, // You can store the total records of the grid here
      accountingGroupSearchForm: {
        accountingGroupCode: '',
        isActive: SWITCH_VALUE.blank,
        isResellerGroup: SWITCH_VALUE.blank,
      },
    },
    parentGlobalModal: {
      openParentGlobalCustomerNoModal: false, // You can store ParentGlobalCustomerNo modal open status here
      gridParentGlobalCustomerNoRowSelectedData: [], // You can store the grid row selected data here
      gridParentGlobalGridRowSelectedCount: 0,
      parentGlobalGridTotalRecords: 0,
      parentGlobalGridData: [],
      errorModal: null,
      customerNameSearchTerm: '',
      showCustomernameSelectedValue: null,
      name: [],
      isParentGlobalResultsFound: true,

      parentGlobalModalMultipleInputs: {
        name: '',
        accountingGroup: '',
        accountingGroupName: '',
        parentPsCustomerCode: '',
        activeFlag: '',
        corporateCustomer: '',
        billtoCustomer: '',
        pageIndex: GRID_ROWS_PER_PAGE.initialVal,
        recordCount: GRID_ROWS_PER_PAGE.entitlementsGlobalCustomerNumberGrid,
      },
      parentGlobalModalDropDownValues: {
        activeFlag: ERP_SALES_ORDER_ITEMS_DATA.dropDownDefaultValueForAny,
        corporateCustomer:
          ERP_SALES_ORDER_ITEMS_DATA.dropDownDefaultValueForAny,
        billtoCustomer: ERP_SALES_ORDER_ITEMS_DATA.dropDownDefaultValueForAny,
      },
    },

    selectedGlobalCustomerRowData: [], // You can store the selected global customer row data here
    name: [],
    customerNameSearchTerm: '',
    showCustomernameSelectedValue: null,
  },

  //--Smart Search--
  //Customer Name Contains
  customerNameSearchTerm: '',
  showCustomernameSelectedValue: null,
  customerName: [],
  selectedCustomerNameInputValue: {
    name: '',
    accountingGroup: '',
    parentPsCustomerCode: '',
    activeFlag: '',
    corporateCustomer: '',
    billtoCustomer: '',
    pageIndex: 0,
    recordCount: GRID_ROWS_PER_PAGE.customers,
  },
  multipleInputsSelectedValues: {
    name: '',
    accountingGroup: '',
    parentPsCustomerCode: '',
    activeFlag: '',
    corporateCustomer: '',
    billtoCustomer: '',
    pageIndex: 0,
    recordCount: GRID_ROWS_PER_PAGE.customers,
  },

  //Order Group Contains
  orderGroupSearchTerm: '',
  showOrdergroupSelectedValue: null,
  orderGroup: [],
  selectedOrderGroupInputValue: {
    id: '',
    prefixCode: '',
    name: '',
    pageIndex: 0,
    recordCount: GRID_ROWS_PER_PAGE.orderGroup,
  },
  ordergroupmultipleInputsSelectedValues: {
    id: '',
    prefixCode: '',
    name: '',
    pageIndex: 0,
    recordCount: GRID_ROWS_PER_PAGE.orderGroup,
  },

  //--DropDowns--
  //Import Status
  importStatusData: [],

  //Mapping Type
  mappingTypeData: [],

  //Column Filters
  erpSalesOrderItemsColData: [],
  //ERP Sales Order Items Search Grid Column Filters
  erpSalesOrderItemsGridColumnFilters: {
    orderNumber: '',
    shipDate: '',
    importDate: '',
    customerName: '',
    siteName: '',
    orderGroup: '',
  },

  //User Details
  user: '',
  userId: 0,
  erpSalesOrderItemsEnititlementLoading: false,
  erpSalesOrderItemsEnititlement: [],
  entitlementsTotalRecords: 0,
  createEntitlementLoading: false,
  createEntitlementFound: null,
  resetLineLoading: false,
  resetLineFound: null,
  jobCreateEntitlementLoading: false,
  onSaveRefreshSearch: false,
  fromErpSalesOrderNavigate: false,
};
